import axios from 'axios';

import { getUser } from '../auth/auth';

export const backendClient = axios.create({
    baseURL: import.meta.env.VITE_BACKEND,
    timeout: 60000,
});

export const publicBackendClient = axios.create({
    baseURL: import.meta.env.VITE_BACKEND,
    timeout: 60000,
});

export const backendClientInterceptor = () =>
    backendClient.interceptors.request.use(
        (config) => {
            const cfg = config;
            const user = getUser();
            const token = user?.access_token;
            if (token) {
                // config.headers.Authorization = `Bearer ${token}`;
                cfg.headers.Authorization = `Bearer ${token}`;
            }
            return cfg;
        },
        (error) => Promise.reject(error)
    );
